import { render, staticRenderFns } from "./SyncList.vue?vue&type=template&id=6749d8ab&"
import script from "./SyncList.vue?vue&type=script&lang=js&"
export * from "./SyncList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports